@switch (content.statusCode) {
  @case (404) {
    <app-not-found />
  }
  @case (401) {
    <app-unauthorized />
  }
  @case (403) {
    <app-unauthorized />
  }
  @default {
    <!--
    TODO Move margin and padding classes to users of this component to prevent unnecessary margins (e.g. ShiftPage).
    -->
    <zenith-notification
      class="mx-3 my-3"
      zn-appearance="error"
      [attr.zn-heading]="'components.error.title' | translate"
      zn-open>
      <zenith-notification-content>
        @if (content.messages) {
          @for (errorMessage of content.messages; track errorMessage.code; ) {
            <p>{{ errorMessage.translation }}</p>
          }
        } @else {
          <p>{{ error.message | translate }}</p>
        }
      </zenith-notification-content>
    </zenith-notification>
  }
}

